import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import Header from "../../Dashboard/Header";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

const BankTransactionsList = () => {
  const navigate = useNavigate();
  // Transaction data
  const transactions = [
    {
      id: 1,
      srNo: "1",
      date: "02/02/2020",
      description:
        "03599100002500Int.Rea01-11-2019 to 31 -01-2020 EBANKFHirsaos To HIT HUF",
      type: "Receipt",
      amount: 84,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 2,
      srNo: "2",
      date: "03/03/2020",
      description: "03599200002627B Int.S81.00 and TAX 0.00",
      type: "Receipt",
      amount: 12000,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 3,
      srNo: "3",
      date: "05/03/2020",
      description: "ASR4-SRCABCS.012003810190058",
      type: "Payment",
      amount: 17.7,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 4,
      srNo: "4",
      date: "16/03/2020",
      description: "NET+000251260490-HTESH HKAKADIA HUF",
      type: "Receipt",
      amount: 250000,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 5,
      srNo: "5",
      date: "18/03/2020",
      description: "NET+000251260967-KAKADIA HITESHBH AH MASBHBHAI",
      type: "Receipt",
      amount: 300000,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 6,
      srNo: "6",
      date: "17/03/2020",
      description: "EBANKFfrom Hirash To H HUF",
      type: "Receipt",
      amount: 390000,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 7,
      srNo: "7",
      date: "19/03/2020",
      description: "FOR FOR-RIGIRAJ-RIGIRAJ-RIGIRAJ",
      type: "Payment",
      amount: 1000000,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 8,
      srNo: "8",
      date: "20/03/2020",
      description: "NET+A079201098119745-TRAJEDEAL FI NANCIAL SERVICES",
      type: "Receipt",
      amount: 12490.18,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 9,
      srNo: "9",
      date: "21/03/2020",
      description: "EBANKFfrom Hirash To HIT HUF",
      type: "Receipt",
      amount: 131038,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
    {
      id: 10,
      srNo: "10",
      date: "30/03/2020",
      description: "08590300058279 Int.S81.00 and TAX 0.00",
      type: "Receipt",
      amount: 581,
      suggestedLedger: "",
      ledger: "Select Ledger",
    },
  ];

  // Columns configuration
  const columns = [
    { field: "srNo", headerName: "Sr. No.", width: 80 },
    { field: "date", headerName: "Date", width: 120 },
    {
      field: "description",
      headerName: "Description",
      width: 350,
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {params.value}
        </div>
      ),
    },
    { field: "type", headerName: "Type", width: 120 },
    {
      field: "amount",
      headerName: "Amount",
      width: 120,
      renderCell: (params) => (
        <div style={{ textAlign: "right" }}>
          {params.value.toLocaleString()}
        </div>
      ),
    },
    {
      field: "suggestedLedger",
      headerName: "Suggested Ledger",
      width: 150,
    },
    {
      field: "ledger",
      headerName: "Ledger",
      width: 150,
      renderCell: (params) => (
        <FormControl fullWidth size="small">
          <Select value={params.value} onChange={() => {}} displayEmpty>
            <MenuItem value="Select Ledger">Select Ledger</MenuItem>
            <MenuItem value="Ledger 1">Ledger 1</MenuItem>
            <MenuItem value="Ledger 2">Ledger 2</MenuItem>
            <MenuItem value="Ledger 3">Ledger 3</MenuItem>
          </Select>
        </FormControl>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: () => (
        <Button variant="outlined" size="small">
          Actions
        </Button>
      ),
    },
  ];

  return (
    <Box mt="80px" ml="20px" mr="20px">
     <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Bank Transactions" subtitle={`Transactions for SBI`} />
        <Button
          onClick={() => navigate("/Infinite/ExcelCompare")}
          sx={{
            backgroundColor: "black",
            color: "white",
            "&:hover": {
              backgroundColor: "#333", // hover color
            },
          }}
        >
          Back
        </Button>
      </Box>
      {/* Bulk Operations Section */}
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle2">Transaction Type:</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Select Type</InputLabel>
              <Select label="Select Type">
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Receipt">Receipt</MenuItem>
                <MenuItem value="Payment">Payment</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Button>Save</Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Transactions Table */}
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Setting Started
        </Typography>
        <div style={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={transactions}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            checkboxSelection
            disableSelectionOnClick
          />
        </div>
      </Paper>
    </Box>
  );
};

export default BankTransactionsList;
